import { environment } from '@lla-platform/core/core-util'

export const SHOPS_API_URL = {
  allShops: `${environment.apiUrl}/locations`,
  statusBoard: `${environment.apiUrl}/locations/status-board`,
  attentionSummary: `${environment.apiUrl}/locations/attention-summary`,
  editLocationAttention: (locationId: string) =>
    `${environment.apiUrl}/locations/${locationId}/attention`,
  getAllRegionalManagers: `${environment.apiUrl}/locations/regional-managers`,
  getAllDistrictManagers: `${environment.apiUrl}/locations/district-managers`,
  getAllLocationGroups: `${environment.apiUrl}/locations/location-groups`,
  allVendors: `${environment.apiUrl}/vendors`,
  vendorsSummaryByLevel: `${environment.apiUrl}/vendors/summary-by-level`,
  preferredVendors: `${environment.apiUrl}/vendors/preferred`,
  preferredVendorsByLocation: (locationId: string) =>
    `${environment.apiUrl}/vendors/preferred/${locationId}`,
  copyPreferredVendors: (locationId: string) =>
    `${environment.apiUrl}/vendors/preferred/${locationId}/copy`,
  exportPreferredVendors: `${environment.apiUrl}/vendors/preferred/export`,
  vendorsList: `${environment.apiUrl}/vendors/filters`,
  vendorDocument: (vendorDocumentId: string) =>
    `${environment.apiUrl}/vendors/documents/${vendorDocumentId}`,
  exportVendorsList: `${environment.apiUrl}/vendors/filters/export`
}
